module.exports = __webpack_public_path__ + "img/tickets-r3-req.2e52e3f0.png";